import { createSelector } from 'reselect';

const selectSingleFyrk = state => state.get('fyrksingle');

const makeSelectFyrk = () =>
  createSelector(selectSingleFyrk, fyrkState => fyrkState.get('fyrk'));

export { selectSingleFyrk, makeSelectFyrk };
